import { useLocation, Navigate, useParams, useSearchParams } from 'react-router-dom'
import { boolean } from 'boolean'

import { useAuth } from 'hooks/useAuth'
import { objectToSearchString } from 'serialize-query-params'

export function InviteGuard({ children }: { children: JSX.Element }) {
	// Support both /accept-invite/:id and /accept-contact-share/:inviteToken route shapes
	const { id, inviteToken } = useParams()
	const inviteId = id ?? inviteToken
	const location = useLocation()
	const [searchParams] = useSearchParams()
	const email = searchParams.get('email')
	const searchParamsString = objectToSearchString({ email })
	const { token, authInfo, requireOtp } = useAuth()

	if (requireOtp) {
		return (
			<Navigate
				to={`/auth/mfa${searchParamsString ? `?${searchParamsString}` : ''}`}
				state={{ from: location, inviteId }}
				replace
			/>
		)
	}

	if (token && authInfo) {
		const { isDeleted, isComplete } = authInfo

		if (boolean(isDeleted)) {
			return (
				<Navigate
					to={`/auth/recover${searchParamsString ? `?${searchParamsString}` : ''}`}
					state={{ from: location, inviteId }}
					replace
				/>
			)
		}
		if (!boolean(isComplete)) {
			return (
				<Navigate
					to={`/auth/sign-up-2${searchParamsString ? `?${searchParamsString}` : ''}`}
					state={{ from: location, inviteId }}
					replace
				/>
			)
		}
	}

	return children
}
